import { BrowserRouter as Router, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { useEffect, useCallback, useMemo, useState } from 'react';
import './App.css';
import GridInput from './pages/GridInput.js';
import Analysis from './pages/Analysis.js';
import Home from './pages/Home';
import Login from './pages/Login.js';
import TestPage from './pages/TestPage.js';
import TestPage2 from './pages/TestPage2.js';
import TestPage3 from './pages/TestPage3.js';
import TestPage4 from './pages/TestPage4.js';
import Total1 from './pages/Total1.js';
import Total2 from './pages/Total2.js';
import Total3 from './pages/Total3.js';

import api from './api/axiosConfig.js';

function App() {

  const [userName, setUserName] = useState(() => {
    return localStorage.getItem('userName') || '';
  });

  const [userId, setUserId] = useState('');

  const [memoOpen, setMemoOpen] = useState(false);
  const [memoText, setMemoText] = useState(() => {
    return localStorage.getItem('memo') || '';
  });

  //메모 저장
  const handleMemoSave = () => {
    api.post(`/api/Home/memoSave`, {userId, memoText})
      .then(() => { alert('저장되었습니다.'); })
      .catch(err => {
        if (err.response?.status === 409) alert(err.response.data);
        else alert('저장 중 오류가 발생했습니다.\n' + err);
      });
  };

  // 사용자정보 세팅
  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');

    if (storedUserId) {
      setUserId(storedUserId);

      // 서버에서 최신 정보 가져오기
      api.get(`/api/login/userInfo?userId=${storedUserId}`)
        .then((res) => {

          const fetchedName = res.data?.name || res.data?.NAME || '';
          const fetchedMemo = res.data?.memo || res.data?.MEMO || '';

          setUserName(fetchedName);
          setMemoText(fetchedMemo);
          localStorage.setItem('userName', fetchedName);
          localStorage.setItem('memo', fetchedMemo);
        })
        .catch((err) => console.error(err));
    }
  }, []);

  // ✅ 메모 팝업이 열릴 때 재조회
  useEffect(() => {
    if (memoOpen && userId) {
      api.get(`/api/login/userInfo?userId=${userId}`)
        .then((res) => {
          const fetchedMemo = res.data?.memo || res.data?.MEMO || '';
          setMemoText(fetchedMemo);
        })
        .catch(err => console.error('메모 재조회 실패:', err));
    }
  }, [memoOpen, userId]);

  // 로그인 상태를 관리하는 state
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return sessionStorage.getItem('isLoggedIn') === 'true';
  });

  // 로그인
  const handleLogin = (newUserId) => {
    setIsLoggedIn(true);
    sessionStorage.setItem('isLoggedIn', 'true');

    // 여기서 상태를 업데이트해야 네비게이션 바에 즉시 반영됩니다.
    setUserId(newUserId);
    localStorage.setItem('userId', newUserId);

    // 사용자 이름도 바로 가져오고 싶다면 여기서 API 호출을 한 번 더 하거나
    // Login.js에서 이름까지 받아서 넘겨주는 것이 좋습니다.
    api.get(`/api/login/userInfo?userId=${newUserId}`)
      .then((res) => {
        const fetchedMemo = res.data?.memo || res.data?.MEMO || '';
        const fetchedName = res.data.name || res.data.NAME || '';
        setUserName(fetchedName);
        setMemoText(fetchedMemo);
        localStorage.setItem('userName', fetchedName);
        localStorage.setItem('memo', fetchedMemo);
      })
      .catch(console.error);

  };

  const handleLogout = useCallback(() => {
    setIsLoggedIn(false);
    sessionStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userId');
    localStorage.removeItem('memo');
    localStorage.removeItem('userName');
    localStorage.removeItem('token');

    setUserName(''); // 상태 초기화

    // alert("로그아웃되었습니다.");
  }, []);

  useEffect(() => {
    const handleUnauthorized = () => {
      console.warn("세션 만료 또는 토큰 오류로 자동 로그아웃 처리됩니다.");
      handleLogout();
    };

    window.addEventListener('unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('unauthorized', handleUnauthorized);
    };
  }, [handleLogout]); // handleLogout이 변경될 때만 리스너 재등록

  const myPage = () => {
    console.log("마이페이지")
  }


  // 로그인되지 않았을 경우, 로그인 페이지를 렌더링
  if (!isLoggedIn) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<Login onLogin={handleLogin} />} />
          {/* 로그인하지 않은 사용자가 다른 경로로 접근 시 로그인 페이지로 리디렉션 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    );
  }

  // 로그인된 경우, 기존의 메인 화면을 렌더링
  return (
    <Router>
      <div className="app-wrapper">
        <nav className="navbar">
          <ul className="menu">
            <li><NavLink to="/home">홈</NavLink></li>
            <li><NavLink to="/mainData">매출매입 등록</NavLink></li>
            <li><NavLink to="/testPage">현장 등록</NavLink></li>
            <li><NavLink to="/testPage2">거래처 등록</NavLink></li>
            <li><NavLink to="/analysis">기간별 조회</NavLink></li>
            <li><NavLink to="/testPage4">현장별 조회</NavLink></li>
            <li><NavLink to="/total1">매출정산서</NavLink></li>
            <li><NavLink to="/total2">총괄정산서</NavLink></li>
            <li><NavLink to="/total3">수금현황</NavLink></li>
          </ul>
          <div className="navbar-right">
            {/* 메모 영역 추가 */}
            <div className="memo-wrapper">
              <button
                className={`memo-btn ${memoText ? 'has-memo' : ''}`}
                onClick={() => setMemoOpen(prev => !prev)}
                title="메모"
              >
                📝
              </button>

              {memoOpen && (
                <div className="memo-dropdown">
                  <div className="memo-dropdown__header">
                    <span>메모</span>
                    <button className="memo-close" onClick={() => setMemoOpen(false)}>✕</button>
                  </div>
                  <textarea
                    className="memo-textarea"
                    value={memoText}
                    onChange={e => setMemoText(e.target.value)}
                    placeholder="메모를 입력하세요"
                  />
                  <div className="memo-dropdown__footer">
                    <button className="btn btn-primary" onClick={handleMemoSave}>저장</button>
                    <button className="btn btn-ghost" onClick={() => setMemoOpen(false)}>닫기</button>
                  </div>
                </div>
              )}
            </div>

            {/* 사용자 프로필 영역 */}
            <div className="user-profile" onClick={myPage}>
              <div className="user-avatar">
                {userName ? userName[0] : 'U'}
              </div>
              <span className="user-name">{userName}님</span>
            </div>

            {/* 로그아웃 버튼 */}
            <button className="logout-btn" onClick={handleLogout}>
              로그아웃
            </button>
          </div>
        </nav>

        <main className="container">
          <div className="card">
            <Routes>
              {/* 홈 페이지는 로그인 후 기본 경로로 설정 */}
              <Route path="/home" element={<Home />} />
              <Route path="/mainData" element={<GridInput />} />
              <Route path="/analysis" element={<Analysis />} />
              <Route path="/testPage" element={<TestPage />} />
              <Route path="/testPage2" element={<TestPage2 />} />
              <Route path="/testPage3" element={<TestPage3 />} />
              <Route path="/testPage4" element={<TestPage4 />} />
              <Route path="/total1" element={<Total1 />} />
              <Route path="/total2" element={<Total2 />} />
              <Route path="/total3" element={<Total3 />} />
              {/* 로그인 후 기본 경로로 리디렉션 */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;